import { render, staticRenderFns } from "./detailDrone.vue?vue&type=template&id=1b2609e4&scoped=true&"
import script from "./detailDrone.vue?vue&type=script&lang=js&"
export * from "./detailDrone.vue?vue&type=script&lang=js&"
import style0 from "./detailDrone.vue?vue&type=style&index=0&id=1b2609e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2609e4",
  null
  
)

export default component.exports